export default "__VITE_ASSET__C9DA1qZg__"